import {TSPlot} from "../components/TSPlot";
import BaseLayout from "../layout/BaseLayout";

export default function LoadProfilePage() {
    return (
            <BaseLayout child={<TSPlot />}/>
    )
}